import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class AccountsList extends Component {
  constructor(props) {
    super(props);

    var currentTime = new Date();

    this.state = {
      accounts: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" },
      fromMonth: new Date(currentTime.getFullYear(), currentTime.getMonth(), 1),
      toMonth: new Date(
        currentTime.getFullYear(),
        currentTime.getMonth() + 1,
        0
      )
    };
  }

  componentDidMount() {
    this.onFilterClick();

    // axios
    //   .get(
    //     (process.env.NODE_ENV !== "development"
    //       ? appConst.API_URL_PROD
    //       : appConst.API_URL_DEV) + "/account"
    //   )
    //   .then(response => {
    //     this.setState({ accounts: response.data });
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Accounts List</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
                name="Income"
              >
                Add Income
              </button>
              <button
                onClick={this.onAddClick}
                className="btn btn-primary btn-sm mb-2 mr-2"
                name="Expense"
              >
                Add Expense
              </button>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
                name="Edit"
              >
                Edit
              </button>
              {/* &nbsp;&nbsp;
              <button
                onClick={this.onPrintClick}
                className="btn btn-primary btn-sm mb-2"
                name="Print"
              >
                Print
              </button> */}
              &nbsp;&nbsp; From Month &nbsp;
              <DatePicker
                selected={this.state.fromMonth}
                onChange={e => this.setState({ fromMonth: e })}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
              &nbsp;&nbsp; To Month &nbsp;
              <DatePicker
                selected={this.state.toMonth}
                onChange={e => this.setState({ toMonth: e })}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
              &nbsp;
              <button
                onClick={this.onFilterClick}
                className="btn btn-primary btn-sm mb-2"
                name="Filter"
              >
                Filter
              </button>
            </div>
            <AgGridReact
              rowData={this.state.accounts}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            >
              <AgGridColumn field="_id" hide="true" />
              <AgGridColumn
                width={50}
                checkboxSelection
                filter={false}
                resizable
              />

              <AgGridColumn
                field="txndate"
                headerName="Date"
                width={120}
                sortable
                resizable
                filter
                valueFormatter={this.dateFormatter}
              />
              <AgGridColumn
                field="desc"
                headerName="Description"
                width={200}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="type"
                headerName="Type"
                width={100}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="txntype"
                headerName="Transaction Type"
                width={130}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="paymentMode"
                headerName="Payment Mode"
                width={100}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="amount"
                headerName="Amount"
                width={150}
                sortable
                resizable
                filter
                valueFormatter={this.currencyFormatter}
              //cellStyle={this.incomeColor}
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  incomeColor(params) {
    return { color: "darkgreen" };
  }

  expenseColor(params) {
    return { color: "red" };
  }

  currencyFormatter(params) {
    var parts = (params.value < 0 ? params.value * -1 : params.value)
      .toString()
      .split(".");
    return (
      parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      (parts[1] ? "." + parts[1] : ".00")
    );
  }

  dateFormatter(params) {
    var arr = params.value.split("-");
    return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
  }

  onAddClick = e => {
    var tar = e.target.name;
    this.props.onClick("", this.state.dummy, tar);
  };

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length == 1)
      this.props.onClick(
        "AddEdit",
        selectedNodes[0].data,
        selectedNodes[0].data.txntype
      );
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select One Entry !!"
      });
    }
  };

  onPrintClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);
    const selectedDataStringPresentation = selectedData
      .map(node => node._id)
      .join(",");

    const ip = {
      count: selectedNodes.length,
      ids: selectedDataStringPresentation
    };

    if (selectedNodes.length > 0) this.props.onClick("PrintMultiple", ip);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Entry !!"
      });
    }
  };

  onFilterClick = e => {
    const obj = {
      fromDate: this.state.fromMonth,
      toDate: new Date(
        this.state.toMonth.getFullYear(),
        this.state.toMonth.getMonth() + 1,
        0
      )
    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/account",
        obj
      )
      .then(response => {
        this.setState({ accounts: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
}

export default AccountsList;
